import { Chip } from "@mui/material";
import useSWR from "swr";

import { API_BASE } from "../config/api";
import { AddressFilters, AddressStatus } from "../types/crm";
import { FetchOptions, SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const BASE = API_BASE.CUSTOMER_ADMIN;

const useCrmAddresses = (
  autoFetch = false,
  options: FetchOptions | null = null,
  filters: AddressFilters = {},
) => {
  let swrUrl = `${BASE}/addresses`;
  if (options?.fetchOne && options?.id) {
    swrUrl = `${BASE}/addresses/${options.id}`;
  }

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, filters] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  const getStatusChip = (status: AddressStatus) => {
    switch (status) {
      case "active":
        return <Chip label="Active" color="success" size="small" />;
      case "pending":
        return <Chip label="Pending" color="warning" size="small" />;
      case "rejected":
        return <Chip label="Rejected" color="error" size="small" />;
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  const getStatusOptions = () => [
    { label: "All Statuses", value: "" },
    { label: "Active", value: "active" },
    { label: "Pending", value: "pending" },
    { label: "Rejected", value: "rejected" },
  ];

  return {
    data,
    dataLoading,
    mutate,
    error,
    getStatusChip,
    getStatusOptions,
  };
};

export default useCrmAddresses;
